import { FC, useState } from "react";
import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledTableCell } from "../../parametrage/Pays/Pays";
import { ICommissionCommerciauxDRC } from "./ICommissionCommerciauxDRC";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { cellStyle } from "../../parametrage/Pays/RowPays";
import SecondNiveauCommission from "./SecondNiveauCommission";

interface RowCommissionCommerciauxGrcProps {
  userWithArticleCommission: ICommissionCommerciauxDRC;
}

const RowCommissionCommerciauxGrc: FC<RowCommissionCommerciauxGrcProps> = ({
  userWithArticleCommission,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <>
      <TableRow>
        <TableCell align="center">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
            sx={{ color: "#fff", fontSize: 12 }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell style={cellStyle} align="center">
          {userWithArticleCommission?.prenom}
        </TableCell>
        <TableCell style={cellStyle} align="center">
          {userWithArticleCommission?.name}
        </TableCell>
        <TableCell style={cellStyle} align="center">
          {userWithArticleCommission?.email}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={cellStyle} colSpan={4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <StyledTableCell style={cellStyle} align="center">
                      Client
                    </StyledTableCell>
                    <StyledTableCell style={cellStyle} align="center">
                      Operation
                    </StyledTableCell>
                    <StyledTableCell style={cellStyle} align="center">
                      désignation article
                    </StyledTableCell>
                    <StyledTableCell style={cellStyle} align="center">
                      mois - année
                    </StyledTableCell>
                    <StyledTableCell style={cellStyle} align="center">
                      Type{" "}
                    </StyledTableCell>
                    <StyledTableCell style={cellStyle} align="center">
                      CA
                    </StyledTableCell>
                    <StyledTableCell style={cellStyle} align="center">
                      Taux de commission
                    </StyledTableCell>
                    <StyledTableCell style={cellStyle} align="center">
                      Commission
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userWithArticleCommission?.herArticleWithCommission?.map(
                    (article) => (
                      <SecondNiveauCommission article={article} />
                    )
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default RowCommissionCommerciauxGrc;
